module.exports = __webpack_public_path__ + "media/images/529s/apple-touch-icon-152x152-915c82ea16b8088741d199a70f012392.png";